export const PaginationRouterQueryKey = {
  Page: 'page',
} as const;

export const FIRST_PAGE = 1;
